import PropTypes from 'prop-types';
import React, { useEffect } from 'react';

import NavigateTo from 'actions/current_location/navigate_to';
import connect from 'components/lib/connect';

function EmbeddedReport({
  embeddedReport,
  onTimezoneChange,
  reloadReport,
  resetEmbeddedReportLoading,
  setEmbeddedReportLoading,
}) {
  const onMessageEvent = e => handleMessageEvent(e, onTimezoneChange, resetEmbeddedReportLoading);

  useEffect(() => {
    window.addEventListener('message', onMessageEvent);
    return () => {
      window.removeEventListener('message', onMessageEvent);
      resetEmbeddedReportLoading();
    };
  }, []);

  if (embeddedReport.hasUsedUrl) {
    reloadReport();
    return null;
  }

  embeddedReport.useUrl();
  setEmbeddedReportLoading();
  return (
    <iframe
      id="lkr-embedded-dashboard"
      src={embeddedReport.expiringUrl.url}
      frameBorder="0"
      height="100%"
      scrolling="no"
      width="100%"
    />
  );
}

export function handleMessageEvent(event, onTimezoneChange, resetEmbeddedReportLoading) {
  if (event.origin === 'https://gladly.looker.com') {
    let data;
    try {
      data = JSON.parse(event.data);
    } catch (e) {
      data = null;
    }

    if (data) {
      switch (data.type) {
        case 'page:changed':
          if (data.page && data.page.type === 'dashboard') {
            if (data.page.absoluteUrl) {
              let absoluteUrl = new URL(data.page.absoluteUrl);
              let absoluteUrlSearchParams = new URLSearchParams(absoluteUrl.search);
              if (absoluteUrlSearchParams.has('query_timezone')) {
                let timezone = absoluteUrlSearchParams.get('query_timezone');
                timezone = timezone === 'user_timezone' || timezone === 'query_saved' ? '' : timezone;
                onTimezoneChange(timezone);
              }
            }
          }
          break;
        case 'dashboard:run:complete':
          resetEmbeddedReportLoading();
          break;
        default:
          return;
      }
    }
  }
}

EmbeddedReport.propTypes = {
  embeddedReport: PropTypes.object,
  onTimezoneChange: PropTypes.func,
  reloadReport: PropTypes.func,
  resetEmbeddedReportLoading: PropTypes.func,
  setEmbeddedReportLoading: PropTypes.func,
};

const mapStateToProps = ({ getProvider }) => {
  return {
    currentLocationProvider: getProvider('currentLocation'),
  };
};

const mapExecuteToProps = executeAction => {
  return {
    onTimezoneChange: (currentLocationProvider, timezone) => {
      const currentLocation = currentLocationProvider.get();
      if (currentLocation.getTimezone() !== timezone) {
        executeAction(NavigateTo, currentLocation.deriveNew({ timezone }));
      }
    },
    reloadReport: currentLocationProvider => {
      executeAction(NavigateTo, currentLocationProvider.get());
    },
  };
};

const mergeProps = (stateProps, executeProps, ownProps) => {
  return {
    ...ownProps,
    // add currentLocation to execute props
    onTimezoneChange: timezone => executeProps.onTimezoneChange(stateProps.currentLocationProvider, timezone),
    reloadReport: () => executeProps.reloadReport(stateProps.currentLocationProvider),
  };
};

export default connect(mapStateToProps, mapExecuteToProps, mergeProps)(EmbeddedReport);



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/reporting/report/embedded_report.jsx